import { render } from "./PermissionClone.vue?vue&type=template&id=eb82145c"
import script from "./PermissionClone.vue?vue&type=script&lang=js"
export * from "./PermissionClone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__